import { connect } from 'react-redux'
import React, { Component } from 'react'
import CloseIcon from 'react-icons/lib/md/close'
import Player from '../../misc/player/Player'

class ZoomOverlay extends Component {

  constructor() {
    super()
    this.state = {

    }

    this.setState = this.setState.bind(this)
  }

  render() {
    return (
      <div className="zoom-backdrop" onClick={this.props.onClose}>
        <div className="zoom-header">
          <div
            key="close"
            className="close-icon"
            onClick={this.props.onClose}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="zoom-content">
          <div style={{ maxWidth: this.state.width }}>
            <div className="zoom-title">{this.props.video.title}</div>
            <Player
              onSizeChange={(w, h) => {
                this.setState({ width: w })
              }}
              me={this.props.me}
              video={this.props.video}
              onClick={(e) => {
                e.stopPropagation()
              }}
              mobile={this.props.isMobile}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect()(ZoomOverlay)
